'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { FeatherFlame, FeatherSnowflake, FeatherThermometer } from '@subframe/core';
const getTemperatureIcon = (temp: string): ReactNode => {
  switch (temp) {
    case 'Quente':
      return <FeatherFlame className="h-4 w-4" />;
    case 'Morna':
      return <FeatherThermometer className="h-4 w-4" />;
    case 'Fria':
      return <FeatherSnowflake className="h-4 w-4" />;
    default:
      return null;
  }
};
interface NegociacaoTemperatureBadgeProps {
  temperature: string;
  getTemperatureColorClass: (temp: string) => string;
}
export function NegociacaoTemperatureBadge(t0) {
  const $ = _c(17);
  const {
    temperature,
    getTemperatureColorClass
  } = t0;
  let t1;
  if ($[0] !== getTemperatureColorClass || $[1] !== temperature) {
    t1 = getTemperatureColorClass(temperature);
    $[0] = getTemperatureColorClass;
    $[1] = temperature;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== temperature) {
    t2 = getTemperatureIcon(temperature);
    $[3] = temperature;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== getTemperatureColorClass || $[9] !== temperature) {
    t4 = getTemperatureColorClass(temperature);
    $[8] = getTemperatureColorClass;
    $[9] = temperature;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = `text-caption-bold font-caption-bold ${t4}`;
  let t6;
  if ($[11] !== t5 || $[12] !== temperature) {
    t6 = <span className={t5}>{temperature}</span>;
    $[11] = t5;
    $[12] = temperature;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <div className="flex items-center gap-1.5 rounded-full border border-solid border-neutral-200 bg-neutral-50 px-3 py-1">{t3}{t6}</div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
interface NegociacaoTemperatureRowProps {
  temperature: string;
  getTemperatureColorClass: (temp: string) => string;
}
export function NegociacaoTemperatureRow(t0) {
  const $ = _c(17);
  const {
    temperature,
    getTemperatureColorClass
  } = t0;
  let t1;
  if ($[0] !== getTemperatureColorClass || $[1] !== temperature) {
    t1 = getTemperatureColorClass(temperature);
    $[0] = getTemperatureColorClass;
    $[1] = temperature;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== temperature) {
    t2 = getTemperatureIcon(temperature);
    $[3] = temperature;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== getTemperatureColorClass || $[9] !== temperature) {
    t4 = getTemperatureColorClass(temperature);
    $[8] = getTemperatureColorClass;
    $[9] = temperature;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = `text-body-xs-semibold ${t4}`;
  let t6;
  if ($[11] !== t5 || $[12] !== temperature) {
    t6 = <span className={t5}>{temperature}</span>;
    $[11] = t5;
    $[12] = temperature;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <div className="flex items-center gap-2">{t3}{t6}</div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}